import galleryAdapter from '../gallery/adapter'
import dayjs from 'dayjs'
import api from '../../api'

export const subAdapter = {
  gallery: galleryAdapter,
  order: {
    responseBodyToRender(internal, external){
      let output = []

      handleInternal()
      handleExternal()

      function handleInternal(){
        if(internal && internal.length > 0){
          for (let index = 0; index < internal.length; index++) {
            const element = internal[index];
            output.push({
              id: element.pkParticipantInternalId,
              order: element.nomorTiket,
              name: element.namaIndividu,
              user_id: element.userId,
              guests: 1,
              // unread: true
            },)
          }
        }
      }

      function handleExternal(){
        if(external && external.length > 0){
          const byUserId = {}
          const byUserIdName = {}

          for (let index = 0; index < external.length; index++) {
            const element = external[index];

            if(!byUserId[element.userYangMendaftarkan.userId]){
              byUserId[element.userYangMendaftarkan.userId] = [
                {
                  id: element.pkParticipantEksternalId,
                  order: element.nomorTiket,
                  name: element.nama,
                  guests: 1,
                  // unread: true
                }
              ]
              byUserIdName[element.userYangMendaftarkan.userId] = element.userYangMendaftarkan.namaIndividu
            } else {
              byUserId[element.userYangMendaftarkan.userId].push(
                {
                  id: element.pkParticipantEksternalId,
                  order: element.nomorTiket,
                  name: element.nama,
                  guests: 1,
                  // unread: true
                }
              )
            }
          }

          console.log({byUserId})

          if(Object.keys(byUserId).length > 0){
            const ids = Object.keys(byUserId)
            for (let index = 0; index < ids.length; index++) {
              const id = ids[index];
              output.push({
                id: byUserId[id][0]?.order,
                order: byUserId[id][0]?.order,
                name: byUserIdName[id],
                user_id: id,
                guests: byUserId[id].length,
                ids: byUserId[id].map(d => d.id),
                guests_data: byUserId[id]
                // unread: true
              },)
            }
          }
        }
      }

      return output
    }
  }
}

const adapter = {
  responseBodyToForm(input){
    let output = {}

    if(input){
      const {
        eventId,
        judulActivity,
        // deskripsiPendek,
        deskripsiPanjang,
        tanggalMulai,
        tanggalSelesai,
        imgThumbnail,
        imgMainImage,
        statusActivity,
        typeAudience,
        typeApproach,
        typeIssues,
        lokasi = [],
        lokasiOnline = [],
        tag,
        galleries,

        activityOrganizing = {},
        totalLikes,
        submission,
        catatanModerasi
      } = input

      const {
        pkActivityOrganizingId,
        urlRegistrasiEksternal,
        activityParticipantEksternal,
        activityParticipantInternal,
        participantSeat,
        registrationStartDate,
        registrationEndDate,
      } = activityOrganizing

      const location = lokasi[0] ? lokasi[0] : {}
      const { provinsi, kota, jalan, pinLocation } = location

      const isInternal = !urlRegistrasiEksternal || urlRegistrasiEksternal === null || urlRegistrasiEksternal === 'N/A'
      const registrationType = isInternal ? 'internal' : 'external'

      const activityOrganizingFields = {
        pkId: pkActivityOrganizingId,
        external_link: urlRegistrasiEksternal,
        guest_total: (activityParticipantEksternal?.length + activityParticipantInternal?.length) || 0,
        guest_seat: participantSeat,
        last_registration_start_date: dayjs(registrationStartDate).format('YYYY-MM-DD'),
        last_registration_start_time: dayjs(registrationStartDate).format('HH:mm'),
        last_registration_end_date: dayjs(registrationEndDate).format('YYYY-MM-DD'),
        last_registration_end_time: dayjs(registrationEndDate).format('HH:mm'),
        registration_start_date: dayjs(registrationStartDate).format('YYYY-MM-DD'),
        registration_start_time: dayjs(registrationStartDate).format('HH:mm'),
        registration_end_date: dayjs(registrationEndDate).format('YYYY-MM-DD'),
        registration_end_time: dayjs(registrationEndDate).format('HH:mm'),
        guest_data: subAdapter.order.responseBodyToRender(activityParticipantInternal, activityParticipantEksternal)
      }

      let onlineLocation = {
        location_online_is_empty: false,
        location_online_id: null,
        location_online_channel: null,
        location_online_url: null,
        location_online_email: '',
        location_online_phone: '',
        location_online_need_update: false
      }
      if(lokasiOnline.length === 0){
        const newOnlineLocation = {
          ...onlineLocation,
          location_online_is_empty: true
        }
        onlineLocation = newOnlineLocation
      } else {
        const firstOnlineLocation = lokasiOnline[0]
        if(firstOnlineLocation){
          const {
            pkLokasiOnlineId,
            contactPerson: cpEmail,
            telpReservasi: cpPhone,
            typeChannel = {
              id: null,
              nama: []
            },
            url
          } = firstOnlineLocation

          const newOnlineLocation = {
            ...onlineLocation,
            location_online_id: pkLokasiOnlineId,
            // location_online_channel: typeChannel.id,
            location_online_channel: {
              label: typeChannel?.nama?.[0],
              value: typeChannel?.id
            },
            location_online_url: url,
            location_online_email: cpEmail,
            location_online_phone: cpPhone
          }
          onlineLocation = newOnlineLocation
        }
      }

      output = {
        id: eventId,
        registrationType,
        title_en: judulActivity[1],
        title_id: judulActivity[0],
        suitable: matchOptions(typeAudience),
        approach: matchOptions(typeApproach),
        issue: matchOptions(typeIssues),
        tags: matchTags(tag),
        gallery_saved: subAdapter.gallery.responseBodyToForm(galleries),
        event_start_date: dayjs(tanggalMulai).format('YYYY-MM-DD'),
        event_end_date: dayjs(tanggalSelesai).format('YYYY-MM-DD'),
        event_start_time: dayjs(tanggalMulai).format('HH:mm'),
        event_end_time: dayjs(tanggalSelesai).format('HH:mm'),
        about_en: deskripsiPanjang[1],
        about_id: deskripsiPanjang[0],
        province: {label: provinsi, value: provinsi},
        city: kota,
        address: jalan,
        pin_point: pinLocation,
        image: api.base_image+imgMainImage,
        thumbnail: api.base_image+imgThumbnail,
        location_id: location.pkLokasiActivityId,
        total_likes: totalLikes,
        submission_status_id: submission,
        reason: catatanModerasi,
        status_activity_id: statusActivity.id,

        ...onlineLocation,
        ...activityOrganizingFields
      }
    }

    return output
  }
}

function matchOptions(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.nama[0],
        value: element.id
      })
    }
  }

  return result
}

function matchTags(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.pilihanTagId.nama[0],
        value: element.pilihanTagId.id
      })
    }
  }

  return result
}

export default adapter
